import React from 'react';
import PropTypes from 'prop-types';

const ArrowLeft = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="14" viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.88856 12.8327L1.33301 6.99935M1.33301 6.99935L6.88856 1.16602M1.33301 6.99935L14.6663 6.99935"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ArrowLeft.propTypes = {
  color: PropTypes.string,
};

export default ArrowLeft;
